<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('HOLIDAY.ITEMS') }} </v-toolbar-title>

      <v-spacer />

      <v-btn dark color="indigo" @click="create()">

        {{ $t('HOLIDAY.ITEM_CREATE') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="pa-5" tile>
      <holidays-list-filter :value="filters" @setRequest="setFilters" />

      <holidays-list
        :meta="meta"
        :holidays="holidays"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="600"
    >
      <component
        :is="component.name"
        :data="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import HolidaysList from '../components/HolidaysList.vue';
import HolidaysListFilter from '../components/HolidaysListFilter.vue';
import DataOptions from '@/modules/_global/classes/DataOptions';
import moment from 'moment/moment';
import { HolidaysService } from '@/services/holidays.service';

export default {
  name: 'HolidaysPage',

  components: {
    HolidaysList,
    HolidaysListFilter,
    EditHoliday: () => import('@/modules/holidays/components/EditHoliday'),
    CreateHoliday: () => import('@/modules/holidays/components/CreateHoliday')
  },

  data() {
    return {
      meta: {},
      holidays: [],
      filters: {
        period: moment()
          .year()
          .toString()
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['date'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    refreshData() {
      HolidaysService.getList(this.params).then(({ data }) => {
        this.holidays = data.data;
        this.meta = data.meta;
      });
    },

    setFilters(filters) {
      this.filters = filters;
    },

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateHoliday'
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },
    show(item) {
      this.dialog = true;
      this.component = {
        name: 'EditHoliday',
        data: item
      };
    }
  }
};
</script>

<style scoped></style>
